import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, mergeProps as _mergeProps, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "contentHeader flex relative" }
const _hoisted_2 = { class: "relative ml-2" }
const _hoisted_3 = { class: "absolute" }
const _hoisted_4 = { class: "contentBox flex-col" }
const _hoisted_5 = { class: "block w-full" }
const _hoisted_6 = { class: "flex mb-4" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "ml-auto" }
const _hoisted_10 = { class: "text-center" }

import {onBeforeUnmount, onMounted, reactive, ref} from 'vue';
import { BryntumGrid } from "@bryntum/grid-vue-3";
import {Menu, Store, StringHelper} from "@bryntum/grid";
import GridInputFilter from "@/components/GridInputFilter";
import { useGlobalStore } from "@/stores/GlobalStore";
import Autorefresh from "@/components/Autorefresh.vue";
import {DisdiStateType, ErrorLocationType, PopupType, TableType} from '@/utilities/enums/Enums';
import Error from "@/components/Error";
import {useI18n} from "vue-i18n";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {$t} from "@/utilities/i18n/config";
import {checkboxColumnConfig, defaultSpaceAroundTableOnPage, permissionColumn} from "@/AppConfig";
import FilterService from "@/utilities/services/FilterService";
import {GeneralResponse} from "@/models/api/Responses";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {RegistrationService} from "@/utilities/services/entities/RegistrationService";
import {LocationService} from "@/utilities/services/entities/LocationService";
import router from "@/router";
import {PermissionService} from "@/utilities/services/PermissionService";
import {LocationRegistrationStatus} from "@/models/registration/LocationRegistrationStatus";



export default /*@__PURE__*/_defineComponent({
  __name: 'LocationReports',
  setup(__props) {

const gridStore = new Store();
const globalStore = useGlobalStore();

const { t } = useI18n();
const registrationService = new RegistrationService();
const locationService = new LocationService();
const permissionService = new PermissionService();

let selectedReports = ref([]);

const openRegisterPopup = () => {
  globalStore.openPopup({
    data: {},
    action: setGridData,
    resetButton: false,
    title: $t("locationsReports.registerPopup"),
    type: PopupType.registerPopup
  });
}
const openInstantMessages = () => {
  globalStore.openPopup({
    data: {ids:selectedReports.value.map(r => r.id), message:""},
    action:sendInstantMessage,
    resetButton:false,
    title:$t("locationsReports.instantMessage"),
    type:PopupType.locationReportsPopup
  });
}

const toggleAutoRefresh = () => {
  globalStore.refreshIsActive = !globalStore.refreshIsActive;
}

// reads ids and message form glaobalStore which should be updated correctly by locationReportsPopup
const sendInstantMessage = async () => {
  const ids = globalStore.modal.contentObject.ids;
  const message = globalStore.modal.contentObject.message;

  const notifyResp = await locationService.postSendMessageToRegisteredUsers(ids, message);
  if (notifyResp === null || notifyResp === undefined || notifyResp.statusCode !== 0){
    ErrorHandler.handleError(notifyResp as GeneralResponse, ErrorLocationType.popup);
    return;
  }

  globalStore.closeModal();
  globalStore.showSuccess(t('global.send'));
}

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage}px`;
};

const grid = ref(null);
const useGridConfig = {
  relayStoreEvents: true,
  height: currentWindowHeight,
  headerMenuFeature: false,
  cellTooltipFeature: {
    hoverDelay      : 300,
    textContent     : true,
    hideOnDelegateChange: true,
  },
  enableTextSelection: true,
  selectionMode : {
    row: true,
    checkbox: checkboxColumnConfig,
    showCheckAll: true,
    deselectFilteredOutRecords: true
  },
  columns : {
    data: [    
      {
      id: 'computedStatus',
      field: 'computedStatus',
      text: "",
      width: 30,
      minWidth: 30,
      type: "template",
          template: ({ record }: { record: any }): string => {
            return record.data.computedStatus
                ? `<div class="userActivity isActive"></div>`
                : `<div class="userActivity"></div>`;
        }
      },
      {
        id:'name',
        field: 'name',
        text: t('locationsReports.grid.name'),
        flex: 1,
      },
      {
        id: 'infoButton',
        field: 'infoButton',
        text: t('registrationReports.grid.info'),
        width: 36,
        sortable: false,
        type: "template",
        template: () => {
          return `<div class='gridRowButton'><span class='icon-info'></span></div>`;
        },
      },
      { id:'group1Name', field: 'group1Name', text: t('locationsReports.grid.group1'), flex: 1 },
      { id:'group2Name', field: 'group2Name', text: t('locationsReports.grid.group2'), flex: 1 },
      { id:'controlCenterName', field: 'controlCenterName', text: t('locationsReports.grid.controlCenter'), flex: 1 },
      { id:'contactInfo.phoneNumber', field: 'contactInfo.phoneNumber', text: t('locationsReports.grid.phone'), flex: 1 },
      {
        id:'address',
        field: 'address',
        text: t('locationsReports.grid.adress'),
        flex: 1,
        type: 'template',
        template: ({record})=>{
          return StringHelper.xss`${record.data.contactInfo.street ?? ""} ${record.data.contactInfo.streetNumber ?? ""}, ${record.data.contactInfo.postalCode ?? ""} ${record.data.contactInfo.city ?? ""}`;
        }
      },
      {
        id:'personCount',
        field: 'personCount',
        text: t('locationsReports.grid.personCount'),
        flex: 1,
        type: 'template',
        template: ({record})=>{
          const t = record.data.registrationStatus === undefined
              ? undefined
              : new LocationRegistrationStatus(record.data.registrationStatus);
          return StringHelper.xss`${t?.totalPersonCount() ?? ""}`;
        }
      },
      {
        id:'safetyInstructionInfo',
        field: 'safetyInstructionInfo',
        text: '',
        width   : 36,
        type: "template",
        tooltipRenderer : ({ record }) => {
          if(!record.safetyInstructionInfo?.some(()=>true)) return "";

          const listString = record.data.safetyInstructionInfo?.map((si:any) =>"<li>"+si.name+"</li>").join("");

          return StringHelper.xss`<strong>${t('locationsReports.securityInformations')}:</strong><br/><ol class='securityLists'>`+listString+`</ol>`;
        },
        template: ({ record }) => {
          if(!record.safetyInstructionInfo?.some(()=>true)) return "";
          return `<div class='gridTooltipButton'><span class='icon-sicherheitshinweis'></span></div>`;
        },
      },
      {
        id:'disdi',
        text	: "",
        width   : 36,
        type	: 'template',
        align: "center",
        hidden: !permissionService.userHasPermission("Disdi.Read"),
        resizable: false,
        filterable: false,
        template : ({record}:any)=> {
          return  record.data.hasDisdi && record.data.disdiCount > 0
              ? `<div class='gridRowButton'><span class='icon-liste_tagebuch'></span></div>`
              :  record.data.hasDisdi && record.data.disdiCount === 0
                  ? `<div class='gridRowButtonDisabled'><span class='icon-liste_tagebuch'></span></div>`
                  : "";
        }
      },
      {
        id:'menu',
        text	: '',
        width   : 36,
        type	: 'widget',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        widgets : [{
          type	 : 'button',
          width: 36,
          icon	 : 'icon-kontext_horizontal',
          onAction : ({ source: btn }) => {
            const menu = menuFactory(btn.cellInfo.record.data);
            menu.alignTo({ target: btn })
            menu.show();
          }
        }]
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.registerLocation], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedReports.value = selectedReports.value.concat(event.selected.map(rr => rr.data))
      selectedReports.value = selectedReports.value.filter(r => !event.deselected.map(rr => rr.data).includes(r));
    },
    datachange(){
      globalStore.currentItems = gridStore.count;
      globalStore.allItems = gridStore.originalCount;
    },
    async cellClick({column, record}) {
      if (column.data.field === 'locations' && record.data.safetyInstructionLocations?.length > 0) {
        globalStore.openPopup({
          data: record.data,
          action: globalStore.closeModal,
          title: t('global.locations'),
          type: PopupType.safetyInstructionLocationsPopup
        });
      }

      if(column.data.field === 'infoButton'){
        globalStore.openPopup({
          data:record.data,
          action: () => {},
          resetButton:false,
          title:$t("locationsReports.locationDetails"),
          type:PopupType.locationReportsDetailsPopup
        }, true);
      }

      if(column.data.id === 'disdi'){
        if (!record.data.hasDisdi || (record.data.hasDisdi && record.data.disdiCount === 0)) return;

        globalStore.setLocationName(record.name); 
        globalStore.setRegistrationDate('');  
        globalStore.setReportType(TableType[TableType.registerLocation]);      
        await router.push(`disdi/${TableType[TableType.registerLocation]}/${record.secondaryId}`)
      }
    },
  },
}
const gridConfig = reactive(useGridConfig);

const menuFactory = (record:object) => {
  const menu = new Menu({
    anchor   : true,
    autoShow : true,
    items	: [
      {
        text: t("locationsReports.instantMessage"),
        cls: 'color',
        weight: 100,
        onItem : () => {
          globalStore.openPopup({
            data: {ids:[record.id], message:""},
            action:sendInstantMessage,
            resetButton:false,
            title:$t("locationsReports.instantMessage"),
            type:PopupType.locationReportsPopup
          });
        }
      },
      {
        text: t("locationsReports.locationDetails"),
        cls: 'color',
        weight: 100,
        onItem : ({ menu }) => {
          globalStore.openPopup({
            data:menu.record,
            action: () => {},
            resetButton:false,
            title:$t("locationsReports.locationDetails"),
            type:PopupType.locationReportsDetailsPopup
          }, true);
        }
      },
      {
        text: t("locationsReports.history"),
        cls: 'color',
        weight: 100,
        onItem : ({menu}) => {
          globalStore.openPopup({
            data: menu.record,
            action: globalStore.closeModal,
            title: menu.record.name,
            type: PopupType.locationReportsUserHistoryPopup
          });
        }
      },
    ],
  });

  menu.setRecord(record);

  return menu;
};

const setGridData = async ()=>{
  const locationReportsResp = await registrationService.getLocationReports();
  if (locationReportsResp === null || locationReportsResp === undefined || locationReportsResp.statusCode !== 0) {
    ErrorHandler.handleError(locationReportsResp, ErrorLocationType.table);
    return;
  }

  //  Adding the computedStatus field to each record
  const updatedData = locationReportsResp.locationRegistrationInfo.map((record: any) => ({
        ...record,
        computedStatus: record.registrationStatus?.isLocationBusy || record.registrationStatus?.isBusy ? 1 : 0
  }));

  // Update gridStore with the modified data
  gridStore.setStoreData(updatedData);

  // Apply an initial sort to display assets first
  gridStore.sort('computedStatus', false); // false -> Sort descending (1 first, 0 next)

  gridStore.setStoreData(locationReportsResp.locationRegistrationInfo);

  // apply filters
  gridStore.filter({
    id: "userFilter",
    filterBy: FilterService.buildFilter(TableType[TableType.registerLocation])
  });

  // apply hidden cols
  for(const c of grid.value.instance.value.columns.storage.values){
    const needsHiding = globalStore.userPreferences.userHiddenColumns.some((thc) => thc.attributeName === c.data.field && thc.tableName === TableType[TableType.registerLocation]);

    if(needsHiding && !c.hidden) {
      c.hide();
    }
    else if(!needsHiding && c.hidden && !permissionColumn.includes(c.id)) {
      c.show();
    }
  }

  globalStore.reorderColumns(TableType[TableType.registerLocation]);

  globalStore.closeModal();
}

const setDisdiColumVisibility = async() =>{

  const disdiIsOn = globalStore.settings.disdiSettings?.disdi !== DisdiStateType.NoDISDI;

  if(!disdiIsOn){
    const hasDisdiCol = grid.value.instance.value.columns.getById("disdi");
    hasDisdiCol.hidden = true;
  }
}

onMounted(async ()=>{
  // calculate grid height and sub to window resize event
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(ref(gridStore));
  globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  // start spinner
  globalStore.gridDataIsLoading = true;
  try {
    await setGridData();
    await setDisdiColumVisibility();
  }
  catch (e) {
    console.log(e)
  }

  // stop spinner
  globalStore.gridDataIsLoading = false;
});

onBeforeUnmount(()=>{
  window.removeEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(null);
  globalStore.setGridColumnStore(null);

  globalStore.currentItems = 0;
  globalStore.allItems = 0;
});

return (_ctx: any,_cache: any) => {
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_unref($t)('locationsReports.title')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Autorefresh, { onClick: toggleAutoRefresh })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_unref(Error), {
          errorLoc: _unref(ErrorLocationType).table
        }, null, 8, ["errorLoc"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "primary mr-2",
              disabled: !_unref(selectedReports).some(()=>true),
              onClick: openInstantMessages
            }, [
              _createTextVNode(_toDisplayString(_unref($t)('locationsReports.instantMessage')) + " ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "icon-megaphone" }, null, -1))
            ], 8, _hoisted_7)), [
              [_directive_permission, 'LocationReport.Message.Send']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "primary mr-2",
              onClick: openRegisterPopup,
              title: _unref(t)('locationsReports.newLogin')
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "icon-anmelden" }, null, -1)
            ]), 8, _hoisted_8)), [
              [_directive_permission, 'Registration.Manual']
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(GridInputFilter), {
                gridStore: _unref(gridStore),
                popupType: _unref(PopupType).locationReportsFilterPopup,
                hideFilterButton: false
              }, null, 8, ["gridStore", "popupType"])
            ])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ], 512), [
        [_vShow, !_unref(globalStore).gridDataIsLoading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createVNode(LoadingSpinner)
      ], 512), [
        [_vShow, _unref(globalStore).gridDataIsLoading]
      ])
    ])
  ]))
}
}

})